/**
 * Copyright (c) 2024 itemis AG - All rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Contributors:
 * 	andreas muelder - itemis AG
 *
 *
 *  This config allows overriding ov env variables when the library is
 * used outside of the main web application.
 */

export interface ConfigOptions {
  backendURL: string;
  languageServerURL: string;
  subdiagramsEnabled: boolean;
  layoutEnabled: boolean;
}

let currentConfig: ConfigOptions = {
  backendURL: import.meta.env.VUE_APP_BACKEND_URL,
  languageServerURL: import.meta.env.VUE_APP_LANG_SERVER_URL,
  subdiagramsEnabled: import.meta.env.VUE_APP_SUBDIAGRAMS_ENABLED === "true",
  layoutEnabled: import.meta.env.VUE_APP_LAYOUT_ENABLED === "true",
};

// Function to apply the configuration
export function configure(options: ConfigOptions): void {
  currentConfig = options;
}

export function getConfig(): ConfigOptions {
  return currentConfig;
}
